
import { Store } from "@/store/store";
import { BaseStationsResponse } from "@/models/MonitoringsResponse";
import errorManager from "@/modules/errors/error-services/error-manager";
import { getInfoByState, monitoringStatusClass } from "@/utils/status";
import { ErrorMessage } from "@/models/ErrorMessage";
import MonitoringService from "../MonitoringService";
import { getTime } from "@/utils/time-formatter";
import { optionsStore } from "@/store/options";
import { baseStationStates, georefStateMap } from "@/utils/constants";

class StationsMapStore extends Store {
  data() {
    return {
      params: {
        page: 0,
        size: 2,
        topLeft: [],
        bottomRight: [],
      },
      mapElements: [],
      emit: ()=> {},
      currentController: null,
      recallPosition: {}
    };
  }

  initEmit(emit){
    this.state.emit=emit;
  }
  // 4# set the parameter for the call 
  setView(view){
    this.state.params.topLeft=view.topLeft
    this.state.params.bottomRight= view.bottomRight
    
    this.state.recallPosition.zoom = view.zoom
    this.state.recallPosition.center = view.center;
  }
  async getStations(params,signal) {
    console.log("get stations");
    if(params.topLeft&&params.bottomRight&&params.topLeft.length>0&&params.bottomRight.length>0){
      console.log("getting pages station page",params.page);
    //let copyParams= params?params:Object.assign({},params )
    return MonitoringService.getMonitoringMapPaginated(params,signal)
      .then((apiResponse) => {
        return Promise.resolve(new BaseStationsResponse(apiResponse.data));
      })
      .catch((error) => {
        return errorManager.manage(
          error,
          error,errorManager.case("CanceledError",() =>
            Promise.resolve(new BaseStationsResponse({}))),
          errorManager.caseNotFound(() =>
            Promise.resolve(new BaseStationsResponse({}))
          ),
          errorManager.case("ServerError", 
            ()=>{
              errorManager.clean()
              Promise.resolve(new BaseStationsResponse({}))})
          
        );
      });} else {console.log('params are',this.state.params, params);}
  }
    async getMonitoringStations() {
      console.log("Trigger interrogate on monitoring pagination ...");
      if (this.currentController) {
        console.log("Aborting previous requests");
        this.currentController.abort();
      }
       // Create a new AbortController for the current batch
      this.currentController = new AbortController();
      const { signal } = this.currentController;
      try {        
        const response = await MonitoringService.getMonitoringMapPaginated(
          this.state.params,signal
        );
        console.log(response);
        let result_1 = new BaseStationsResponse({});
        if (response.data) {
          result_1 = new BaseStationsResponse(response.data);
          if(result_1.totalElements<this.state.mapElements.length){
            console.log("Trigger count elements",result_1.totalElements, this.state.mapElements.length);
            this.state.mapElements=[]
          }
        }
        let pages = result_1.pagination.pages;
        console.log('RESULT first',result_1.pagination);
        let currentPage = result_1.pagination.currentPage;
        let copyParams= Object.assign({}, this.state.params )
        for (let index = currentPage; index < pages; index++) {

          this.sleep(300)
          copyParams.page=index;
          //setTimeout(() => { Promise.resolve(this.call(copyParams,signal)) }, 300);
         Promise.resolve(this.call(copyParams,signal));
        }
        return await Promise.resolve(result_1);
      } catch (error) {
        console.log(error);
        return await errorManager.manage(
          error,errorManager.case("CanceledError",() =>
            Promise.resolve(new BaseStationsResponse({}))),
          errorManager.caseNotFound(() =>
            Promise.resolve(new BaseStationsResponse({}))
          ),
          errorManager.case("ServerError", 
              ()=>{
                errorManager.pushError(new ErrorMessage(error,"error retriving position "+this.state.params.topLeft+' ' +this.state.params.bottomRight, error["details"]?error["details"]:500));
                Promise.resolve(new BaseStationsResponse({}))}),
          errorManager.defaultCase(() => {
            errorManager.pushError(error);
            return Promise.resolve(new BaseStationsResponse({}))
          })
        );
      }
    }
  async call(params,signal) {
    this.getStations(params,signal).then((response) => {
      let newElements = this.getPositions(response.data);
      const terms = [
        ...this.state.mapElements,
        ...newElements,
      ];
      
      // using reducer on all terms update those lements that result different and those that areadd the  new ones 
      const mappingElements=terms.reduce((acc, item) => {
        if (typeof acc[item.id] === 'undefined') {
          // set default value for each term as 0
          acc[item.id] = item;
        }       
        return acc;
      }, {})
      newElements.forEach(newItem => {
        mappingElements[newItem.id] = newItem;
      });
      this.state.mapElements = Object.values(mappingElements);
    });
  }
          sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
          }
  getPositions(baseStations) {
    
    console.log("LOADpositions",baseStations);
    let result = baseStations.map((bs) => {
      let stat = [
        { label: "ID", value: "id" },
        { label: "Base Station", value: "baseStation" },
        { label: "Nickname", value: "info" },
        { label: "IMEI", value: "imei" },
        { label: "Label Groups", value: "accessLabels" },
        { label: "Location", value: "address" },
        { label: "Installer", value: "installer" },
      ];
      const isNewAntenna = bs.georefState === 'NEW_ANTENNA';
      const statusBgStyle = isNewAntenna
        ? `style="background:#1565c0;color:#fff;" class="px2 text-center"`
        : `class="${monitoringStatusClass(bs.state, 'px2 text-center')}"`;
      let status = `<div ${statusBgStyle}>
        ${bs.state ? getInfoByState(bs.state).name : "loading ..."}
      </div>`;
      const statusUpdateBgStyle = isNewAntenna
        ? `style="background:#1565c0;color:#fff;opacity:.9;" class="px2 text-center"`
        : `class="${monitoringStatusClass(bs.state, 'px2 text-center')}"`;
      let statusLastUpdate = bs.statusUpdatedAt ? `<div ${statusUpdateBgStyle}> updated
        ${getTime((new Date().getTime() - bs.statusUpdatedAt) / 1000,
          optionsStore.getState().locale,
          optionsStore.getState().timezone)} ago
      </div>` : '';
      const georefMeta = georefStateMap[bs.georefState];
      const georefBlock = georefMeta
        ? `<div style="text-align:center;padding:4px 8px;border-bottom:1px solid #eee;">
            <span style="background:${georefMeta.color};color:#fff;font-size:10px;font-weight:700;padding:2px 8px;border-radius:3px;text-transform:uppercase;letter-spacing:.3px;">${georefMeta.label}</span>
           </div>`
        : '';
      let content = () => {
        let result = "";
        for (let i = 0; i < stat.length; i++) {
          result = bs[stat[i].value]
            ? result +
              `<div><strong>${stat[i].label}: </strong> ${
                bs[stat[i].value]
              }</div>`
            : result;
        }
        return result;
      };
      let popup = status + statusLastUpdate + georefBlock + content();
      return {
        id:bs.item.id,
        state:bs.state,
        latLong: bs.item.info.coordinates,
        marker: isNewAntenna ? "INFO" : this.getIconMarker(bs.state),
        popup: popup,
        onclick: () => this.state.emit(bs) ,
      };
    });
    console.log("getpos", result);
    return result;
  }
   getIconMarker(state) {
    if (state == baseStationStates.notActive) {
      return "ERROR";
    }
    if (state == baseStationStates.active) {
      return "SUCCESS";
    }
    if(state==baseStationStates.authorized){
      return "WARN"
    } 
    if(state==baseStationStates.idle){
      return "IDLE"
    }
    return null;
  }
  async loadNewMap(){
    
    console.log("LOAD in store");
    this.state.mapElements =[];
    let mountpoints=await this.getMapMountpoints()
    this.state.mapElements = this.getPositions(mountpoints.data)
    
    console.log("LOAD",this.state.mapElements);
  }
  async getMapMountpoints(){
    console.log("LOAD get map");
    return MonitoringService.getMapMountpoints(this.state.params)
    .then((apiResponse) => {
      console.log("LOAD get map response");
      return Promise.resolve(new BaseStationsResponse({data:apiResponse.data}));
    })
    .catch((error) => {
      console.log("LOAD get map errr");
      return errorManager.manage(
        error,
        error,errorManager.case("CanceledError",() =>
          Promise.resolve(new BaseStationsResponse({}))),
        errorManager.caseNotFound(() =>
          Promise.resolve(new BaseStationsResponse({}))
        ),
        errorManager.case("ServerError", 
          ()=>{
            errorManager.clean()
            Promise.resolve(new BaseStationsResponse({}))})
        
      );
    });

    
  }
}

export const stationsMapStore = new StationsMapStore("STATIONS-MAP");
